import React from 'react';
import * as Styles from 'pages/member/wh/WH.style';
import { Trans, useTranslation } from 'react-i18next';
import CustomButton from 'components/common/custom-button';
import { Message } from 'components/alert/Message';
import { scrollToSection } from 'utils';
import UseWh from 'hooks/use-wh';
import priceCalculator from 'utils/price-calculator';
import { P } from 'components/reusable-css';
import { useSelector } from 'react-redux';
import { UpperCaseWord } from 'assets/css/common-styles';
import { Icon } from 'semantic-ui-react';

const WHLastStep = ({ formikProp, isLoading }) => {
  const { t } = useTranslation();
  const userAccount = useSelector((state) => state.user.account);
  const { validateForm, handleSubmit, values, isValid } = formikProp;
  const { withoutDomainPriceYearly, withoutDomainPriceMonthly } = UseWh({ formikProp });
  return (
    <Styles.NewVMLastStepSC>
      <Styles.PriceServer>
        <Styles.Content>
          <P className="price">{t('wh/create.string1')}</P>
          <Styles.Price>
            <Styles.PerMonth>
              <Trans
                i18nKey={
                  values.options_prepaid === 1
                    ? 'wh/create.string3'
                    : values.options_prepaid === 12
                    ? 'wh/create.string4'
                    : 'wh/create.string5'
                }
                values={{
                  price:
                    values.options_prepaid === 1
                      ? priceCalculator(withoutDomainPriceMonthly, false)
                      : values.options_prepaid === 12
                      ? priceCalculator(withoutDomainPriceYearly, false)
                      : priceCalculator(withoutDomainPriceMonthly * 96, false),
                  currency: userAccount.account_currency,
                  currency_symbol: userAccount.account_currency_symbol,
                }}
                components={{ uppercase: <UpperCaseWord />, price: <Styles.PriceUnit /> }}
              />
            </Styles.PerMonth>
          </Styles.Price>
        </Styles.Content>
        <Styles.flexBlueContainer>
          <Styles.BlueInfo>
            <Icon name="lightbulb" />
            <P>{t('wh/create.step5_string12')}</P>
          </Styles.BlueInfo>
        </Styles.flexBlueContainer>
      </Styles.PriceServer>
      <Styles.VirtualServer>
        <Styles.SubmitServer>
          <CustomButton
            isLoading={isLoading}
            title={t('wh/create.string2')}
            onClick={async () => {
              const errors = await validateForm();
              handleSubmit();
              if (errors.domain) {
                Message.error(t('string14'), t('string13'));
                return scrollToSection('ST1');
              }
              if (errors.sizes) {
                Message.error(t('string14'), t('string13'));
                return scrollToSection('ST2');
              }
              if (errors.region) {
                Message.error(t('string14'), t('string13'));
                return scrollToSection('ST3');
              }
              if (errors.app) {
                Message.error(t('string14'), t('string13'));
                return scrollToSection('ST4');
              }
            }}
            type="submit"
            buttonStyles={{
              marginLeft: '10px',
              padding: '0.8rem 1rem',
              opacity: !isValid && 0.3,
              backgroundColor: !isValid && 'gray',
            }}
          />
        </Styles.SubmitServer>
      </Styles.VirtualServer>
    </Styles.NewVMLastStepSC>
  );
};

export default WHLastStep;
